const styles = `.activeIndicator {
  background: var(--goto-interactive-01);
  border-radius: 4px 4px 0 0;
  margin-top: 2px;
}

:host .tablist {
  align-self: inherit;
}

:host(.full-width),
:host(.full-width) .tablist {
  width: 100%;
}`; export default styles;